import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";
import Message from 'element-ui/lib/message';
import App from "@/App.vue";
import VueGtag from "vue-gtag";
Vue.use(VueRouter);
const routes = [
    {
        path: "/",
        redirect: "/index"
    }, {
        path: "/login",
        meta: {
            top: false,
            buttom: false,
            title: '登录'
        },
        beforeEnter(to, from, next) {
            // console.log(from);
            // 在路由独享守卫后调用 不！能！获取组件实例 `this`，组件实例还没被创建
            if (store.state.isLoggedIn) {
                Message({
                    message: '您已登录，请勿重复登录',
                    type: 'warning',
                    duration: 1000,
                    onClose: () => {
                        next({ path: from ? from.path : '/index' })
                    }
                });
            } else {
                next()
            }
        },
        component: () => import("@/views/login.vue")
    }, {
        path: "/enrolment",
        meta: {
            top: false,
            buttom: false,
            title: '注册'
        },
        component: () => import("@/views/enrolment.vue")
    }, {
        path: "/resetpass",
        meta: {
            top: false,
            buttom: false,
            title: '重置密码'
        },
        component: () => import("@/views/resetpass.vue")
    }, {
        path: "/index",
        meta: {
            top: true,
            buttom: true,
            title: '首页'
        },
        component: () => import("@/views/index.vue")
    }, {
        path: "/AiDialogue",
        meta: {
            title: 'AI对话',
            huancun: true
        },
        component: () => import("@/views/AiDialogue.vue")
    }, {
        path: "/provacyPolicy",
        meta: {
            top: true,
            buttom: true,
            title: '隐私政策'
        },
        component: () => import("@/views/others/privacyPolicy.vue")
    }, {
        path: "/termsService",
        meta: {
            top: true,
            buttom: true,
            title: '服务条款'
        },
        component: () => import("@/views/others/termsService.vue")
    }, {
        path: "/newsdetail/:id",
        name: "newsdetail",
        meta: {
            top: true,
            buttom: true,
            title: '新闻详情'
        },
        component: () => import("@/views/others/newsdetail.vue")
    }, {
        path: "/paysuccess",
        meta: {
            top: false,
            buttom: false,
            title: '支付成功'
        },
        component: () => import("@/views/others/paysuccess.vue")
    }, {
        path: "/payerror",
        meta: {
            top: false,
            buttom: false,
            title: '支付失败'
        },
        component: () => import("@/views/others/payerror.vue")
    }, {
        path: "/detail/:id",
        name: "details",
        meta: {
            top: true,
            buttom: true,
            title: '详情'
        },
        component: () => import("@/views/details/details.vue")
    }, {
        path: "/reader",
        meta: {
            top: false,
            buttom: false,
            title: '阅读'
        },
        component: () => import("@/views/details/read.vue")
    }, {
        path: "/phoneReader",
        meta: {
            top: false,
            buttom: false,
            title: '阅读'
        },
        component: () => import("@/views/details/appreader.vue")
    },
    {
        path: "/library",
        meta: {
            top: true,
            buttom: false,
            requiresAuth: true,
            title: '我的书架'

        },
        component: () => import("@/views/library/library.vue")
    }, {
        path: "/user",
        meta: {
            top: true,
            buttom: false,
            requiresAuth: true,
            title: '用户中心'
        },
        component: () => import("@/views/user/user.vue")
    }, {
        path: "/userinfo",
        meta: {
            top: true,
            buttom: false,
            requiresAuth: true,
            title: '用户消息'
        },
        component: () => import("@/views/user/userinfo.vue")
    }, {
        path: "/userSet",
        meta: {
            top: true,
            buttom: false,
            requiresAuth: true,
            title: '用户设置'
        },
        component: () => import("@/views/user/userSet.vue")
    },
    {
        path: "/classify",
        meta: {
            top: true,
            buttom: false,
            title: '分类'
        },
        component: () => import("@/views/classify/classify.vue")
    }, {
        path: "/rank",
        meta: {
            top: true,
            buttom: true,
            title: '排行榜'
        },
        component: () => import("@/views/Rank/rank.vue")
    },
    {
        path: "/author/editor",
        name: "detail",
        meta: {
            title: '编辑'

        },
        component: () => import("@/views/Author/BookEditor.vue")
    }, {
        path: "/authorhome",
        meta: {
            requiresAuth: true,
            author: true,
            title: '作者中心'
        },
        beforeEnter(to, from, next) {
            // 在路由独享守卫后调用 不！能！获取组件实例 `this`，组件实例还没被创建
            if (!localStorage.getItem('token')) {
                Message({
                    message: 'Please log in first',
                    type: 'warning',
                    duration: 1000,
                    onClose: () => {
                        next({ path: '/login' })
                    }
                });

            } else {
                next()
            }
        },
        component: () => import("@/views/AuthorCenter/tabpage/homepage.vue")
    }, {
        path: "/author/authorSet",
        meta: {
            requiresAuth: true,
            author: true,
            title: '作者设置'
        },
        beforeEnter(to, from, next) {
            // 在路由独享守卫后调用 不！能！获取组件实例 `this`，组件实例还没被创建
            if (!localStorage.getItem('token')) {
                Message({
                    message: 'Please log in first',
                    type: 'warning',
                    duration: 1000,
                    onClose: () => {
                        next({ path: '/login' })
                    }
                });

            } else {
                next()
            }
        },
        component: () => import("@/views/AuthorCenter/tabpage/authorSet.vue")
    }, {
        path: "/author/bankInfo",
        meta: {
            requiresAuth: true,
            author: true,
            title: '作者信息'
        },
        beforeEnter(to, from, next) {
            // 在路由独享守卫后调用 不！能！获取组件实例 `this`，组件实例还没被创建
            if (!localStorage.getItem('token')) {
                Message({
                    message: 'Please log in first',
                    type: 'warning',
                    duration: 1000,
                    onClose: () => {
                        next({ path: '/login' })
                    }
                });

            } else {
                next()
            }
        },
        component: () => import("@/views/AuthorCenter/tabpage/bankInfo.vue")
    }, {
        path: "/author/Newcontent",
        meta: {
            requiresAuth: true,
            author: true,
            title: '作者内容'
        },
        beforeEnter(to, from, next) {
            // 在路由独享守卫后调用 不！能！获取组件实例 `this`，组件实例还没被创建
            if (!localStorage.getItem('token')) {
                Message({
                    message: 'Please log in first',
                    type: 'warning',
                    duration: 1000,
                    onClose: () => {
                        next({ path: '/login' })
                    }
                });

            } else {
                next()
            }
        },
        component: () => import("@/views/AuthorCenter/tabpage/content.vue")
    }, {
        path: "/author/newslist",
        meta: {
            requiresAuth: true,
            author: true,
            title: '新闻列表'
        },
        beforeEnter(to, from, next) {
            // 在路由独享守卫后调用 不！能！获取组件实例 `this`，组件实例还没被创建
            if (!localStorage.getItem('token')) {
                Message({
                    message: 'Please log in first',
                    type: 'warning',
                    duration: 1000,
                    onClose: () => {
                        next({ path: '/login' })
                    }
                });

            } else {
                next()
            }
        },
        component: () => import("@/views/AuthorCenter/tabpage/message/newslist.vue")
    }, {
        path: "/author/informationlist",
        meta: {
            requiresAuth: true,
            author: true,
            title: '信息列表'
        },
        beforeEnter(to, from, next) {
            // 在路由独享守卫后调用 不！能！获取组件实例 `this`，组件实例还没被创建
            if (!localStorage.getItem('token')) {
                Message({
                    message: 'Please log in first',
                    type: 'warning',
                    duration: 1000,
                    onClose: () => {
                        next({ path: '/login' })
                    }
                });

            } else {
                next()
            }
        },
        component: () => import("@/views/AuthorCenter/tabpage/message/informationlist.vue")
    }, {
        path: "/author/Income",
        meta: {
            requiresAuth: true,
            author: true,
            title: '收入'
        },
        beforeEnter(to, from, next) {
            // 在路由独享守卫后调用 不！能！获取组件实例 `this`，组件实例还没被创建
            if (!localStorage.getItem('token')) {
                Message({
                    message: 'Please log in first',
                    type: 'warning',
                    duration: 1000,
                    onClose: () => {
                        next({ path: '/login' })
                    }
                });

            } else {
                next()
            }
        },
        component: () => import("@/views/AuthorCenter/tabpage/income.vue")
    }, {
        path: "/author/Dshboard",
        meta: {
            requiresAuth: true,
            author: true,
            title: '仪表盘'
        },
        beforeEnter(to, from, next) {
            // 在路由独享守卫后调用 不！能！获取组件实例 `this`，组件实例还没被创建
            if (!localStorage.getItem('token')) {
                Message({
                    message: 'Please log in first',
                    type: 'warning',
                    duration: 1000,
                    onClose: () => {
                        next({ path: '/login' })
                    }
                });

            } else {
                next()
            }
        },
        component: () => import("@/views/AuthorCenter/tabpage/dshboard.vue")
    }, {
        path: "/author/OpenCourses",
        meta: {
            requiresAuth: true,
            author: true,
        },
        beforeEnter(to, from, next) {
            // 在路由独享守卫后调用 不！能！获取组件实例 `this`，组件实例还没被创建
            if (!localStorage.getItem('token')) {
                Message({
                    message: 'Please log in first',
                    type: 'warning',
                    duration: 1000,
                    onClose: () => {
                        next({ path: '/login' })
                    }
                });

            } else {
                next()
            }
        },
        component: () => import("@/views/AuthorCenter/tabpage/openCourses.vue")
    }, {
        path: "/author/WorkPlatform",
        meta: {
            requiresAuth: true,
            author: true,
            huancun: true,
            title: '作品平台'
        },
        beforeEnter(to, from, next) {
            // 在路由独享守卫后调用 不！能！获取组件实例 `this`，组件实例还没被创建
            if (!localStorage.getItem('token')) {
                Message({
                    message: 'Please log in first',
                    type: 'warning',
                    duration: 1000,
                    onClose: () => {
                        next({ path: '/login' })
                    }
                });

            } else {
                next()
            }
        },
        component: () => import("@/views/AuthorCenter/tabpage/workplattab/workbook.vue")
    }, {
        path: "/author/bookset",
        meta: {
            requiresAuth: true,
            author: true,
            title: '书籍更改'
        },
        beforeEnter(to, from, next) {
            // 在路由独享守卫后调用 不！能！获取组件实例 `this`，组件实例还没被创建
            if (!localStorage.getItem('token')) {
                Message({
                    message: 'Please log in first',
                    type: 'warning',
                    duration: 1000,
                    onClose: () => {
                        next({ path: '/login' })
                    }
                });

            } else {
                next()
            }
        },
        component: () => import("@/views/AuthorCenter/tabpage/workplattab/bookset.vue")
    }, {
        path: "/author/workdetail",
        meta: {
            requiresAuth: true,
            author: true,
            title: '作品详情'
        },
        beforeEnter(to, from, next) {
            // 在路由独享守卫后调用 不！能！获取组件实例 `this`，组件实例还没被创建
            if (!localStorage.getItem('token')) {
                Message({
                    message: 'Please log in first',
                    type: 'warning',
                    duration: 1000,
                    onClose: () => {
                        next({ path: '/login' })
                    }
                });

            } else {
                next()
            }
        },
        component: () => import("@/views/AuthorCenter/tabpage/workplattab/workdetail.vue")
    }
]

const scrollBehavior = (to, from, savedPosition) => {
    if (savedPosition) {
        return savedPosition
    } else {
        if (to.meta.huancun) {
            return savedPosition
        } else {
            return { x: 0, y: 0 }
        }
    }
}
const router = new VueRouter({
    routes,
    scrollBehavior
})
Vue.use(VueGtag, {
    config: { id: "G-XPE65LPVCV" },
    appName: 'My application',
    pageTrackerScreenviewEnabled: true,
    pageTrackerExcludedRoutes: ['route_path_value', 'route_name_value'],
    pageTrackerTemplate(to) {
        return {
            page_title: to.meta.title,
            page_path: to.path
        }
    }
}, router);
router.beforeEach((to, from, next) => {
    if (to.path === '/reader') {
        // 检测用户代理是否为移动设备（这里可以根据需要调整正则表达式）
        const isMobile = /iPhone|Android|Windows Phone/i.test(navigator.userAgent);
        if (isMobile) {
            // 如果是移动端，将重定向到 /phonereader，同时传递原有的查询参数
            next({
                path: '/phonereader',
                query: to.query
            });
            return; // 终止后续逻辑
        }
    }
    if (to.matched.some(record => record.meta.requiresAuth)) {
        // 检查用户是否登录，这里假设有一个isAuthenticated函数  
        if (!localStorage.getItem('token')) {
            // 用户未登录，保存当前路由
            Message({
                message: 'Please log in first',
                type: 'warning',
                duration: 1000,
                onClose: () => {
                    next({
                        path: '/login',
                        query: { redirect: to.fullPath } // 也可以将路由信息作为查询参数传递  
                    });
                }
            });

        } else {
            next(); // 确保一定要调用 next()  
        }
    } else {
        next(); // 确保一定要调用 next()  
    }
});
export default router;